var render = function () {
  var _class, _class2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cs-icon",
    class: (_class = {}, _class[_vm.containerSize] = true, _class)
  }, [_c('i', {
    class: (_class2 = {}, _class2[_vm.name] = true, _class2),
    style: {
      backgroundImage: _vm.svgIcon
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }